import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/Login/LoginPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import HomePage from './pages/Home/Home';
import './App.css';
import './global.css';
import './styles/theme.css';
import TransactionsPage from './pages/Transactions/Transactions';
import DailyReportsPage from './pages/DailyReports/DailyReports';
import { ThemeProvider as CustomThemeProvider, useTheme } from './contexts/ThemeContext';
// Import Material-UI ThemeProvider and createTheme
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline'; // Optional: for consistent baseline styles
import { useMemo } from 'react';
import { AppProvider, useAppContext } from './AppContext';

// import { connectDataConnectEmulator } from 'firebase/data-connect';
// import { getDataConnect } from 'firebase/data-connect';
// import { connectorConfig } from './biyuyo-connector';
// const dataConnect = getDataConnect(connectorConfig);
// connectDataConnectEmulator(dataConnect, 'localhost', 9399);

function App() {
  return (
    <AppProvider>
      <CustomThemeProvider>
        <ThemedAppContent />
      </CustomThemeProvider>
    </AppProvider>
  );
}

function ThemedAppContent() {
  const { theme: customTheme } = useTheme();
  const { user, isLoading } = useAppContext();

  const muiTheme = useMemo(() => {
    return createTheme({
      palette: {
        mode: customTheme,
      },
    });
  }, [customTheme]);

  if (isLoading) {
    return (
      <MuiThemeProvider theme={muiTheme}>
        <CssBaseline />
        <div className="App">
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            fontSize: '18px'
          }}>
            Cargando...
          </div>
        </div>
      </MuiThemeProvider>
    );
  }

  return (
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
            <Route path="/dashboard/*" element={user ? <DashboardPage /> : <Navigate to="/login" replace />}>
              <Route path="" element={<HomePage />} />
              <Route path="home" element={<HomePage />} />
              <Route path="transactions" element={<TransactionsPage />} />
              <Route path="daily-reports" element={<DailyReportsPage />} />
              {/* Add other child routes */}
            </Route>
            <Route path="/" element={user ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Router>
    </MuiThemeProvider>
  );
}

export default App;